import { useEffect, useState } from "react";
import axios from "axios";

// const serverUrl = "http://localhost:5000";
const serverUrl = "https://diy-log-server.herokuapp.com";

const Newkeys = () => {
  console.log("newkeys component");
  const [keys, setKeys] = useState({});

  useEffect(() => {
    axios.get(serverUrl + "/newkeys").then((result) => setKeys(result.data));
  }, []);

  return (
    <>
      <h1>New Keys</h1>
      <div className={"keys"}>
        <code>
          API KEY: <code>{keys.publicKey} (this is for your app)</code>
        </code>
        <br />

        <code>
          Secret url :{" "}
          <a href={"https://kazoolog.netlify.app/logs/" + keys.secretKey}>
            https://kazoolog.netlify.app/logs/{keys.secretKey}
          </a>{" "}
          (this is the url to view your logs)
        </code>
      </div>
    </>
  );
};

export default Newkeys;
